<template>
    <div class="container-fluid">
        <button @click="scrollToTop" id="scrollToTopBtn" class="" title="Go to top"><i class="bi bi-caret-up-fill"></i></button>
    </div>
</template>

<script>
export default {
    name: 'toTopButton',
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    mounted() {
        window.onscroll = () => {
            const btn = document.getElementById("scrollToTopBtn");
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                btn.style.display = "block";
            } else {
                btn.style.display = "none";
            }
        };
    }
}
</script>

<style scoped>
#scrollToTopBtn {
    display: none; /* Escondido por padrão */
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 99;
    border: none;
    outline: none;
    background-color: #003867;
    color: white;
    cursor: pointer;
    padding: 10px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 18px;
	opacity: 0.6;
}
#scrollToTopBtn:hover {
	opacity: 1;
    border-color: #ffffff;
    border-style: solid;
    border-width: 1px;
}
</style>